import { api } from "@/lib/api/client";
import type {
  Completion,
  Insight,
  MaintenanceTask,
  Paginated,
  TaskStatus,
} from "./types";

export const tasksApi = {
  list: (facility: number, status?: TaskStatus) => {
    const sp = new URLSearchParams({ facility: String(facility) });
    if (status) sp.set("status", status);
    return api.get<Paginated<MaintenanceTask>>(
      `/api/maintenance-tasks/?${sp.toString()}`,
    );
  },
  get: (id: number) => api.get<MaintenanceTask>(`/api/maintenance-tasks/${id}/`),
  create: (data: Partial<MaintenanceTask> & { item_ids?: number[] }) =>
    api.post<MaintenanceTask>("/api/maintenance-tasks/", data),
  update: (id: number, data: Partial<MaintenanceTask>) =>
    api.patch<MaintenanceTask>(`/api/maintenance-tasks/${id}/`, data),

  accept: (id: number) =>
    api.post<MaintenanceTask>(`/api/maintenance-tasks/${id}/accept/`),
  discard: (id: number) =>
    api.post<MaintenanceTask>(`/api/maintenance-tasks/${id}/discard/`),
  pause: (id: number) =>
    api.post<MaintenanceTask>(`/api/maintenance-tasks/${id}/pause/`),
  resume: (id: number) =>
    api.post<MaintenanceTask>(`/api/maintenance-tasks/${id}/resume/`),
  archive: (id: number) =>
    api.post<MaintenanceTask>(`/api/maintenance-tasks/${id}/archive/`),
};

export const completionsApi = {
  listForTask: (task: number) =>
    api.get<Paginated<Completion>>(`/api/maintenance-completions/?task=${task}`),
  create: (data: { task: number; performed_at: string; notes?: string }) =>
    api.post<Completion>("/api/maintenance-completions/", data),
  confirm: (id: number) =>
    api.post<Completion>(`/api/maintenance-completions/${id}/confirm/`),
};

export const insightsApi = {
  list: (facility: number, dismissed = false) => {
    const sp = new URLSearchParams({ facility: String(facility) });
    if (dismissed) sp.set("dismissed", "1");
    return api.get<Paginated<Insight>>(
      `/api/maintenance-insights/?${sp.toString()}`,
    );
  },
  dismiss: (id: number) =>
    api.post<Insight>(`/api/maintenance-insights/${id}/dismiss/`),
};
